import React from "react";
import { Button, MenuSection, Pane } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import PublisherDetail from "../../routes/publishers/PublisherDetail";
export var DuplicateDetailPane = function (_a) {
    var selectedDuplicatePublisher = _a.selectedDuplicatePublisher, onClose = _a.onClose;
    var formatMessage = useIntl().formatMessage;
    if (!selectedDuplicatePublisher) {
        return null;
    }
    return (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
            id: "ui-br-publishers.duplicateDetailPane.title",
        }), dismissible: true, onClose: onClose, actionMenu: function () { return (React.createElement(MenuSection, { label: formatMessage({
                id: "ui-br-publishers.menu.label.actions",
            }), id: "duplicate-actions-menu" },
            React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    return window.open("/brpublishers/publishers/edit/".concat(selectedDuplicatePublisher.id), "_blank");
                }, fullWidth: true }, formatMessage({
                id: "ui-br-publishers.duplicateDetailPane.button.openEdit",
            })))); } },
        React.createElement(PublisherDetail, { publisher: selectedDuplicatePublisher })));
};
